<template>
  <a-card :bordered="false">
    <search-page-view
      ref="table"
      rowKey="orderNo"
      :itemNames="['search_proId','search_proName','create_button',]"
      :columns="columns"
      :enableSearch="false"
      :queryParams="queryParams"
      :requestPromise="loadPromise"
    >
      <a-form-item slot="search_proId" style="margin-right: 10px">
        <a-input v-model="queryParams.orderNo" placeholder="关联销售订单号"></a-input>
      </a-form-item>
      <a-form-item slot="search_proName">
        <a-input v-model="queryParams.shiJiHuanOrderNo" placeholder="石基环企订单号"></a-input>
      </a-form-item>
      <a-form-item slot="create_button">
        <a-button style="margin-left:15px" type="primary" @click="$refs.table.refresh(true)">查 询</a-button>
      </a-form-item>
      <template slot="userSlot" slot-scope="rowItem">
        <div>{{ rowItem.record.contactName }}</div>
        <div>{{ rowItem.record.contactPhone }}</div>
      </template>
    </search-page-view>
  </a-card>
</template>

<script>
export default {
  name: 'GalasysOrderConnection',
  data() {
    return {
      queryParams: {
        orderNo: '', //名称
        shiJiHuanOrderNo: ''
      },
      loadPromise: params => this.getListPromise(params),
      columns: [
        {
          title: '石基环企订单号',
          dataIndex: 'shiJiHuanOrderNo'
        },
        {
          title: '关联销售订单号',
          dataIndex: 'orderNo'
        },
        {
          title: '票型',
          dataIndex: 'optionName'
        },
        {
          title: '商品名称',
          dataIndex: 'productName',
          width: '20%'
        },
        {
          title: '下单用户',
          dataIndex: 'contactName',
          scopedSlots: { customRender: 'userSlot' }
        },
        {
          title: '订单来源',
          dataIndex: 'channelSources'
        },
        {
          title: '订单状态',
          dataIndex: 'orderStatus'
        },
        {
          title: '供应商名称',
          dataIndex: 'supplierName'
        },
        {
          title: '下单时间',
          dataIndex: 'createOrderTime'
        }
      ]
    }
  },
  mounted() {
    this.$store.commit('SET_MENU_HEAD_CONFIG', [
      { name: 'GalasysConnection', title: '商品绑定' },
      { name: 'GalasysOrderConnection', title: '订单直连' },
      { name: 'GalasysNewAccount', title: '关联账号' }
    ])
  },
  methods: {
    // 获取表格数据接口
    getListPromise(params) {
      this.getLogUtils().logWithTag('==getListPromise==', params)
      return this.getHttpServices().getOrderService().post('shijihuan/getSelectH5ProductList', params)
    }
  }
}
</script>
<style scoped></style>
